import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='componentStep: Flow<NolPayPaymentStep>' mdxType="Item">
      <p>
	<code>NolPayPaymentStep</code> is a class holding different output data for specific steps. Whenever{' '}
	<a href={`#${props.component}.start()`}>start</a> or <a href={`#${props.component}.submit()`}>submit</a> methods are
	called,
	<code>componentStep</code> will trigger the next step in case the call to the mentioned method was successful.
      </p>
      <Group summary='sealed interface NolPayPaymentStep' mdxType="Group">
  <Item title='CollectCardAndPhoneData' mdxType="Item">
  Object representing the step of collecting card and phone data for Nol Pay payment.
  </Item>
  <Item title='CollectTagData' mdxType="Item">
  Object representing the step of collecting tag data for Nol Pay card linking.
  </Item>
  </Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      